/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterData {
    getFixupPrototypeFunction() { return FilterData.fixupPrototype; }

    static newInstance(model: Partial<FilterData>): FilterData {
        let obj = Object.assign(new FilterData(), model);
        FilterData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterData>): FilterData {
        if (!model) return null;
        return FilterData.newInstance(<FilterData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterData) {
        if (!obj) return;

        models.FilterData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterData): boolean {
        Object.setPrototypeOf(obj, FilterData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.regions) {
            for (let val of this.regions) {
                models.ResourceFilterModel.fixupPrototype(val);
            }
        }
        if (this.resource_groups) {
            for (let val of this.resource_groups) {
                models.ResourceFilterModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Displays the list of regions
     */
    regions: Array<models.ResourceFilterModel>;

    /**
     * Displays the list of resource groups
     */
    resource_groups: Array<models.ResourceFilterModel>;

}
